import PropTypes from 'prop-types';

const VolumeOnIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.997.566c.514-.568 1.285-.695 1.991-.442.707.253 1.156.947 1.22 1.642l.001 16.928C36 18.968 38.178 21.24 38.178 24S36 29.032 33.209 29.306v16.862c0 .758-.45 1.453-1.157 1.706-.256.063-.45.126-.706.126-.514 0-.964-.19-1.349-.568L16.572 33.284l-7.206-.001c-.101-.002-.193-.012-.245-.063C4.047 33.03 0 28.925 0 23.873c0-5.053 4.047-9.159 9.121-9.348.064-.063.193-.063.321-.063h6.81zm14.726 13.601c-.676-.902-1.976-1.103-2.913-.451-.936.651-1.144 1.905-.468 2.807a12.221 12.221 0 0 1 2.497 7.468c0 2.706-.884 5.313-2.497 7.468-.676.902-.468 2.155.468 2.807.364.25.78.4 1.197.4.624 0 1.3-.3 1.716-.851A16.344 16.344 0 0 0 48 23.99c0-3.559-1.144-6.967-3.277-9.824z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

VolumeOnIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

VolumeOnIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default VolumeOnIcon;
